/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import {
    AiOutlineFileExcel,
    AiOutlineFileWord,
    AiOutlineFilePdf,
    AiOutlineFileZip,
} from 'react-icons/ai'
import Image from './Image'
import { css } from '@emotion/react'
import { thumbnailSrc } from '../../utils/news'

function Media({ media, thumbnail }) {
    const mime = media?.file?.mime ?? ''
    const ext = media?.file?.ext?.toLocaleLowerCase() ?? ''
    return (
        <div>
            {thumbnail &&
                <div
                    className="my-6 relative h-64 lg:h-80"
                    css={css`
                            img,
                            video {
                                width: 100%;
                                max-height: 500px;
                                object-fit: contain;
                            }
                        `}
                    itemScope
                >

                    <Image
                        src={thumbnailSrc(thumbnail)}
                        layout="fill"
                        width="1200px"
                        height="500px"
                        objectFit="contain"
                        alt={thumbnail?.alt}
                    />
                </div>
            }
            {media && (
                <div className='mt-4 relative'
                    css={css`
                        img,
                        video {
                            width: 100%;
                            max-height: 500px;
                            object-fit: contain;
                        }
                    `}
                >
                    {mime.indexOf(
                        'video'
                    ) === 0 && (
                            <video
                                muted
                                loop
                                controls
                                preload="metadata"
                                width="100%"
                            >
                                <source
                                    src={thumbnailSrc(
                                        media
                                    )}
                                />
                            </video>
                        )}
                    {mime.indexOf(
                        'audio'
                    ) === 0 && (
                            <audio
                                style={{ width: '100%' }}
                                controls
                                src={`/api/filedb/${media.file.hash}.${media.file.ext}#t=0.5`}
                            >
                                <a
                                    href={`/api/filedb/${media.file.hash}.${media.file.ext}#t=0.5`}
                                >
                                    دانلود فایل صوتی
                                </a>
                            </audio>
                        )}
                </div>
            )}
            {/* {mime.indexOf('image/') === 0 && (
                <Image
                    src={
                        media?.file?.hash
                            ? `/api/filedb/${media.file.hash}.${media.file.ext}`
                            : `https://via.placeholder.com/300x150/${media?.file?.name}`
                    }
                    layout="fill"
                    width="1200px"
                    height="500px"
                    objectFit="contain"
                    alt={media?.alt}
                />
            )}
            {mime.indexOf('video/') === 0 && (
                <video muted loop controls preload="metadata">
                    <source
                        src={
                            media?.file?.hash
                                ? `/api/filedb/${media.file.hash}.${media.file.ext}#t=0.5`
                                : `https://via.placeholder.com/300x150/${media?.file?.name}`
                        }
                    />
                </video>
            )} */}
            {ext.indexOf('doc') === 0 && <AiOutlineFileWord />}
            {ext.indexOf('xls') === 0 && <AiOutlineFileExcel />}
            {ext.indexOf('pdf') === 0 && <AiOutlineFilePdf />}
            {['zip', 'rar', 'tar', 'gz', '7z'].indexOf(ext) !== -1 && (
                <AiOutlineFileZip />
            )}
        </div>
    )
}

export default Media
